import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Id, PharmacyAttributes, Practice } from 'ev-types';

type SelectedVisit = {
  visitId: Id | null;
  practice?: Practice;
  preferredPharmacy?: PharmacyAttributes;
};
const selectedVisitInitialState = { visitId: null } as SelectedVisit;

export const selectedVisitSlice = createSlice({
  name: 'selectedVisit',
  initialState: selectedVisitInitialState,
  reducers: {
    selectVisit(state, action: PayloadAction<SelectedVisit>) {
      state.visitId = action.payload.visitId;
      if (action.payload.practice !== undefined) {
        state.practice = action.payload.practice;
      }
    },
    setVisitPreferredPharmacy(
      state,
      action: PayloadAction<PharmacyAttributes>,
    ) {
      state.preferredPharmacy = action.payload;
    },
    setVisitPractice(state, action: PayloadAction<Practice>) {
      state.practice = action.payload;
    },
    clearSelectedVisit(state) {
      state.visitId = null;
      state.preferredPharmacy = undefined;
    },
  },
});
